import { render, staticRenderFns } from "./SelfAppraisal.vue?vue&type=template&id=770e8ecd"
import script from "./SelfAppraisal.vue?vue&type=script&lang=js"
export * from "./SelfAppraisal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports